export function homeFor(session) {
  if (session?.console === "platform") return "/admin/platform";
  if (session?.console === "tenant") return "/admin/tenant";
  const detail = session?.guide?.detail_route;
  if (session?.console === "workspace" && detail && detail !== "/") return detail;
  if (session?.home) return session.home;
  return "/";
}

export function panelFromPath(pathname, prefix) {
  const rest = (pathname || "").replace(prefix, "").replace(/^\//, "");
  return rest || "overview";
}
